// extracted by mini-css-extract-plugin
export var countryCode = "DoubleScreenPopupWithMobileAndCouponCode-module--countryCode--3f98c";
export var coupon = "DoubleScreenPopupWithMobileAndCouponCode-module--coupon--faa95";
export var cross = "DoubleScreenPopupWithMobileAndCouponCode-module--cross--0ae0e";
export var customFont = "DoubleScreenPopupWithMobileAndCouponCode-module--customFont--f55f1";
export var email = "DoubleScreenPopupWithMobileAndCouponCode-module--email--2eeaa";
export var modal = "DoubleScreenPopupWithMobileAndCouponCode-module--modal--a6927";